import { Paper, Text } from "@mantine/core";

interface Props {
  filtered: boolean;
}

export function HeldEmailQueueEmptyState({ filtered }: Props) {
  const message = filtered
    ? "No queued emails match these filters."
    : "No emails are waiting for review.";
  return (
    <Paper p="xl" withBorder>
      <Text c="dimmed" ta="center">
        {message}
      </Text>
    </Paper>
  );
}
